import { combineReducers } from 'redux';
import toastMessageSlice from '../slice/toastMessageSlice';
import channelNavSlice from '../slice/channelNavSlice';
import leftPaneNavSlice from '../slice/leftPaneNavSlice';
import recentChannelListSlice from '../slice/recentChannelSlice';
import channelInfoSlice from '../slice/channelInfoSlice';
import channelConversationSlice from '../slice/channelConversationSlice';
import alertModalSlice from '../slice/alertModalSlice';
import actionModalSlice from '../slice/actionModalSlice';
import userInfoSlice from '../slice/userInfoSlice';
import draftSlice from '../slice/draftSlice';
import channelSelectionSlice from '../slice/channelSelectionSlice';
import invitationsSlice from '../slice/invitationsSlice';
import progressDataSlice from '../slice/progressDataSlice';
import channelMediaPreviewSlice from '../slice/channelMediaPreviewSlice';
import channelMembersSlice from '../slice/channelMembersSlice';
import channelCategoryReducer from '../channels/utils/channelActions/ChannelCategoryReducer';
import menuReducer from '../channels/utils/channelActions/menuActiveStatus';
import exploreChannelsSlice from '../slice/explorechannel';
import themeSlice from '../slice/themeSlice';
import selectedUserSlice from '../slice/selectedUserSlice';
import { commonReducer } from '../slice/commonSlice';
import { callkitDataReducer } from '../features/calls/model/callkitDataSlice';
import activeCallLogData from '../slice/activeCallLogSlice';
import ChatSearchReducer from '../slice/chatSearchSlice';
import ChatFilterReducer from '../slice/chatFilterSlice';
import pinnedMessagesReducer from '../slice/pinnedMessagesSlice';
import replyReducer from '../slice/replySlice';
import keptMessagesReducer from '../slice/keptMessagesSlice';
import scheduledMessagesReducer from '../slice/scheduledMessagesSlice';
import pollReducer from '../slice/pollSlice';
import liveLocationReducer from '../slice/liveLocationSlice';
import outboxReducer from '../slice/outboxSlice';
import publicUserNameReducer from '../slice/publicUserNameSlice';
import linkPreviewReducer from '../slice/linkPreviewSlice';
import contactCardReducer from '../slice/contactCardSlice';
import storiesReducer from '../slice/storiesSlice';
import { navigationReducer } from '../store/navigationSlice';
import { BlockReducer, BlockStatusReducer, contactsWhoBlockedMeReducer } from './BlockReducer';
import { BroadCastReducer } from './BroadCastReducer';
import {
    CallConnectionStateReducer,
    callConversionReducer,
    pinUserReducer,
    largeVideoUserReducer,
    callDurationTimestampReducer,
    callQualityReducer,
    callQualityPopupReducer,
    callQualityIconReducer,
} from './CallReducer';
import { showConfrenceReducer } from './confrenceReducer';
import { ConnectionStateReducer } from './ConnectionStateReducer';
import { FeatureStateReducer } from './FeatureStateReducer';
import { ConversationState } from './ConversationState';
import {
    GroupChatMediaReducer,
    GroupChatMessageReducer,
    GroupChatSelectedMediaReducer,
} from './GroupChatMessageReducer';
import {
    GroupsMemberListReducer,
    GroupsReducer,
    currentCallGroupMembersReducer,
    GroupsMemberParticipantsListReducer,
} from './GroupsReducer';
import { LastActivityReducer } from './LastActivityReducer';
import {
    MessageEditedReducer,
    messageForwardReducer,
    messageInfoReducer,
    MessageReducer,
    selectedMessageInfoReducer,
} from './MessageReducer';
import { PopUp } from './PopUp';
import { PresenceReducer } from './PresenceReducer';
import {
    RecentChatReducer,
    ActiveChatReducer,
    WebChatProfileImageReducer,
    modalPopUpReducer,
} from './RecentChatReducer';
import { RecentChatStatusReducer } from './RecentChatStatusReducer';
import RosterReducer from './RosterReducer';
import {
    SingleChatMediaReducer,
    SingleChatMessageReducer,
    SingleChatSelectedMediaReducer,
    chatSeenPendingMsgReducer,
} from './SingleChatMessageReducer';
import { TypingReducer } from './TypingReducer';
import { groupNotificationMsgCountReducer, UnreadCountReducer, UnreadUserObjReducer } from './UnreadCountReducer';
import { VCardContactReducer, VCardReducer } from './VCardReducer';
import { callLogReducer } from './CallLogReducer';
import {
    browserNotifyReducer,
    browserTabReducer,
    appOnlineStatusReducer,
    webLocalStorageSettingReducer,
} from './BrowserReducer';
import { scrollBottomChatHistoryReducer } from './ScrollReducer';
import { ChatConversationHistoryReducer, EditStatusReducer, LoadMoreChatsMessagesReducer } from './ChatHistory';
import {
    MediaDownloadStateReducer,
    MediaDropdownStatusReducer,
    MediaImageThumbDataReducer,
    UpdateMediaDownloadStateReducer,
    UpdateMediaUploadStateReducer,
} from './Media';
import { starMsgPageTypeReducer, StarredMessagesReducer } from './StarredReducer';
import { TranslateLanguage } from './TranslateLanguage';
import { CommonDataReducer } from './CommonReducer';
import { callIntermediateScreenReducer } from './CallIntermediateScreen';
import { RosterPermissionReducer } from './RosterPermissionReducer';
import { AdminBlockReducer } from './AdminBlockReducer';
import { SettingsReducer } from './SettingsDataReducer';
import { PrivacySettingsReducer } from './PrivacySettingsReducer';

import WallpaperReducer from './WallpaperReducer';
import SyncProgressReducer from './SyncProgressReducer';
import { ReactionReducer } from './ReactionReducer';

export default combineReducers({
    TranslateLanguage: TranslateLanguage,
    modalPopUpReducer: modalPopUpReducer,
    ConnectionStateData: ConnectionStateReducer,
    featureStateData: FeatureStateReducer,
    vCardData: VCardReducer,
    rosterData: RosterReducer,
    recentChatData: RecentChatReducer,
    recentChatStatus: RecentChatStatusReducer,
    conversationState: ConversationState,
    messageData: MessageReducer,
    activeChatData: ActiveChatReducer,
    WebChatProfileImageData: WebChatProfileImageReducer,
    VCardContactData: VCardContactReducer,
    groupsData: GroupsReducer,
    blockedContact: BlockReducer,
    blockStatus: BlockStatusReducer,
    lastActivityData: LastActivityReducer,
    singleChatMsgHistoryData: SingleChatMessageReducer,
    groupsMemberListData: GroupsMemberListReducer,
    groupsMemberParticipantsListData: GroupsMemberParticipantsListReducer,
    presenceData: PresenceReducer,
    typingData: TypingReducer,
    selectedMessageData: messageForwardReducer,
    messageInfoData: messageInfoReducer,
    groupChatMessage: GroupChatMessageReducer,
    callConnectionDate: CallConnectionStateReducer,
    showConfrenceData: showConfrenceReducer,
    SingleChatMediaData: SingleChatMediaReducer,
    GroupChatMediaData: GroupChatMediaReducer,
    SingleChatSelectedMediaData: SingleChatSelectedMediaReducer,
    GroupChatSelectedMediaData: GroupChatSelectedMediaReducer,
    unreadCountData: UnreadCountReducer,
    UnreadUserObjData: UnreadUserObjReducer,
    groupNotificationMsgCount: groupNotificationMsgCountReducer,
    broadCastData: BroadCastReducer,
    popUpData: PopUp,
    currentCallGroupMembersData: currentCallGroupMembersReducer,
    callLogData: callLogReducer,
    callConversionData: callConversionReducer,
    pinUserData: pinUserReducer,
    largeVideoUserData: largeVideoUserReducer,
    callDurationTimestampData: callDurationTimestampReducer,
    browserNotifyData: browserNotifyReducer,
    contactsWhoBlockedMe: contactsWhoBlockedMeReducer,
    scrollBottomChatHistory: scrollBottomChatHistoryReducer,
    browserTabData: browserTabReducer,
    appOnlineStatus: appOnlineStatusReducer,
    chatSeenPendingMsgData: chatSeenPendingMsgReducer,
    chatConversationHistory: ChatConversationHistoryReducer,
    chatEditStatus: EditStatusReducer,
    messageEditedData: MessageEditedReducer,
    mediaUploadData: UpdateMediaUploadStateReducer,
    mediaDownloadingData: UpdateMediaDownloadStateReducer,
    starredMessages: StarredMessagesReducer,
    pinnedMessages: pinnedMessagesReducer,
    reply: replyReducer,
    keptMessages: keptMessagesReducer,
    scheduledMessages: scheduledMessagesReducer,
    poll: pollReducer,
    liveLocation: liveLocationReducer,
    outbox: outboxReducer,
    publicUserName: publicUserNameReducer,
    linkPreview: linkPreviewReducer,
    contactCards: contactCardReducer,
    webLocalStorageSetting: webLocalStorageSettingReducer,
    commonData: CommonDataReducer,
    callIntermediateScreen: callIntermediateScreenReducer,
    contactPermission: RosterPermissionReducer,
    adminBlockData: AdminBlockReducer,
    selectedMessageInfoReducer: selectedMessageInfoReducer,
    mediaDownloadData: MediaDownloadStateReducer,
    mediaDropDownData: MediaDropdownStatusReducer,
    mediaImageThumbData: MediaImageThumbDataReducer,
    LoadMoreChatsMessages: LoadMoreChatsMessagesReducer,
    callQualityData: callQualityReducer,
    callQualityPopup: callQualityPopupReducer,
    callQualityIcon: callQualityIconReducer,
    starMsgPageType: starMsgPageTypeReducer,
    settingsData: SettingsReducer,
    privacySettingsData: PrivacySettingsReducer,
    toastMessageData: toastMessageSlice,
    channelNavData: channelNavSlice,
    leftPaneNavData: leftPaneNavSlice,
    recentChannelListData: recentChannelListSlice,
    channelInfoData: channelInfoSlice,
    channelConversationData: channelConversationSlice,
    alertModalData: alertModalSlice,
    actionModalData: actionModalSlice,
    userInfoData: userInfoSlice,
    draftData: draftSlice,
    channelSelectionData: channelSelectionSlice,
    invitations: invitationsSlice,
    progressData: progressDataSlice,
    channelMediaPreviewData: channelMediaPreviewSlice,
    channelMembersData: channelMembersSlice,
    channelCategory: channelCategoryReducer,
    menu: menuReducer,
    exploreChannelsSlice: exploreChannelsSlice,
    themeData: themeSlice,
    selectedUserData: selectedUserSlice,
    wallpaperData: WallpaperReducer,
    syncProgressData: SyncProgressReducer,
    chatSearch: ChatSearchReducer,
    chatFilter: ChatFilterReducer,
    reactionData: ReactionReducer,
    common: commonReducer,
    callkitData: callkitDataReducer,
    navigationData: navigationReducer,
    activeCallLogData: activeCallLogData,
    stories: storiesReducer,
});
